import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import styles from './resetPassword.module.css';
import { Back } from '../../../Svg';
import api from '../../utils/api';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

const ResetPassword = () => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const { appearences, loading } = useSelector((state) => state.appearences)
    const location = useLocation();
    const navigate = useNavigate()
    const { email } = location.state || {};

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const toggleConfirmPasswordVisibility = () => {
        setConfirmPasswordVisible(!confirmPasswordVisible);
    };

    // Formik setup
    const formik = useFormik({
        initialValues: {

            password: '',
            confirmPassword: ''
        },
        validationSchema: Yup.object({
            password: Yup.string()
                .min(6, 'Password must be at least 6 characters')
                .required('Password is required'),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref('password'), null], 'Passwords must match')
                .required('Confirm Password is required')
        }),
        onSubmit: async (values) => {
            //calling reset password api
            try {
                const response = await api.resetPassword({ email: email, password: values?.password, confirmPassword: values?.confirmPassword })
                if (response.data) {
                    // console.log(response.data);
                    toast.success(response.data?.data?.message || 'Password reset successfully')
                    navigate('/resetSuccess')

                }
            } catch (err) {
                // console.log("respo",err?.response);

                toast.error(err?.response?.data?.message || 'Something went wrong')
            }

        }
    });

    return (
        <div className={styles.loginContainer}
        style={{
            backgroundImage: `url(${appearences?.loginBanner?.image || '/assets/login.png'})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            backgroundAttachment: "fixed",
            backgroundSize: 'cover',
            height: '100vh',
        }}>
            <div className={styles.loginInner}>
                <div className={styles.loginCol1} onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
                    <img src='/assets/logo.png' alt="Logo" />
                </div>
                <div className={styles.loginCol2}>
                    <div className={styles.loginCard}>
                        <div className={styles.backLogin}>
                            <Back />
                            <a href="#"><span>Back to login</span></a>
                        </div>
                        <div className={styles.loginContent}>
                            <h3>Reset Password</h3>
                            <p>Please enter the new password</p>
                            <form className={styles.loginForm} onSubmit={formik.handleSubmit}>
                                {formik.errors.password && formik.touched.password && (
                                    <span className={styles.error}>{formik.errors.password}</span>
                                )}
                                <div className={styles.loginInputGroup}>
                                    <label>Password</label>
                                    <div className={styles.passwordContainer}>
                                        <input
                                            type={passwordVisible ? 'text' : 'password'}
                                            name="password"
                                            placeholder="Enter Password"
                                            value={formik.values.password}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            className={styles.passwordInput}
                                        />
                                        <FontAwesomeIcon
                                            icon={passwordVisible ? faEyeSlash : faEye}
                                            className={styles.passwordIcon}
                                            onClick={togglePasswordVisibility}
                                        />
                                    </div>
                                </div>

                                {formik.errors.confirmPassword && formik.touched.confirmPassword && (
                                    <span className={styles.error}>{formik.errors.confirmPassword}</span>
                                )}
                                <div className={styles.loginInputGroup}>
                                    <label>Confirm Password</label>
                                    <div className={styles.passwordContainer}>
                                        <input
                                            type={confirmPasswordVisible ? 'text' : 'password'}
                                            name="confirmPassword"
                                            placeholder="Confirm Password"
                                            value={formik.values.confirmPassword}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            className={styles.passwordInput}
                                        />
                                        <FontAwesomeIcon
                                            icon={confirmPasswordVisible ? faEyeSlash : faEye}
                                            className={styles.passwordIcon}
                                            onClick={toggleConfirmPasswordVisibility}
                                        />
                                    </div>
                                </div>
                                <button type="submit" className={styles.loginButton} disabled={formik.isSubmitting}>
                                    {formik.isSubmitting ? 'Please wait...' : 'Submit'}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
